import React from 'react'
import styled from 'styled-components'
import { ReactComponent as MenuDots } from '../../Assets/icons/context-menu-icons/optionMenuDots.svg'
import { ReactComponent as AdminBadge } from '../../Assets/icons/adminBadge.svg'
import { displayUserAvatar } from '../../Helpers/chatHelper/AvatarHelper'


const ContactElementChatDetails = ({ item, deliveredInfo, style, displayMenu, isCurrentUserAdmin, isUserAdmin, variant }) => {


    return (
        <Contact style={style}>
            <AvatarWrapper>
                <ContactAvatar>
                    {displayUserAvatar(item)}
                </ContactAvatar>
                {isUserAdmin &&
                    <BadgeWrapper>
                        <AdminBadge />
                    </BadgeWrapper>

                }
            </AvatarWrapper>

            <ContactNameWrapper>
                <ContactName>{item.name}</ContactName>
                {deliveredInfo &&
                    <DeliveredInfo>
                        {deliveredInfo}
                    </DeliveredInfo>
                }
                {isCurrentUserAdmin &&
                    <OptionMenuWrapper >
                        <MenuDots onClick={(e) => displayMenu(e, item)} />
                    </OptionMenuWrapper>
                }
            </ContactNameWrapper>

        </Contact >
    )
}

export default ContactElementChatDetails

const Contact = styled.div`
display:flex;
align-items:center;
gap:10px;
overflow:hidden;
`
const ContactNameWrapper = styled.div`
display:flex;
align-items:center;
width:100%;
overflow:hidden;
gap:10px;
height:100%;
`
const ContactName = styled.p`
 overflow:hidden;
   white-space:nowrap;
     text-overflow:ellipsis;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    text-align: left;
    color: ${({ theme }) => theme.menu.primaryTextColor};
    width: 100%;
`

const AvatarWrapper = styled.div`
  display: flex;
  align-items:center;
  justify-content:center;
position:relative;

`
const ContactAvatar = styled.div`
  display: flex;
  height:42px;
  width:42px;
  position:relative;
`;

const DeliveredInfo = styled.p`
   margin-left:auto;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
white-space:pre;
`

const OptionMenuWrapper = styled.div`
display:flex;
align-items:center;
justify-content:center;
color:${({ theme }) => theme.menu.secondaryTextColor};
margin-left:auto;
cursor:pointer;
svg{
max-height:30px;
max-width:20px;
color:${({ theme }) => theme.menu.infoText};
}
`

const BadgeWrapper = styled.div`
display:flex;
align-items:center;
justify-content:center;
position:absolute;
bottom:-1px;
right:-3px;
z-index:1;
svg{
height:12px;
}
`